<!--
 * @Description: 
 * @Author: 李方强
 * @Date: 2020-03-17 10:47:03
 * @LastEditTime: 2021-12-06 14:06:12
 * @LastEditors: lkz
 -->
<template>
  <div v-if="isShow()" style="float:right">
        <el-popover
          placement="top-start"
          width="400px"
          trigger="hover"
          >
           <!-- <span v-for="(item,index) in recommendList" :key="index" v-html="item.recommendContent" /> -->
           <el-table :data="recommendList">
              <el-table-column width="150" property="recommendContent" label="推荐话术"></el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="70">
                <template slot-scope="scope">
                  <el-button @click="toImEvent(scope.row.recommendContent)" type="text" size="small">推送</el-button>
                </template>
              </el-table-column>
            </el-table>
           <el-button type="text" style="width: 100%;padding:7px 5px;" size="mini" @click="getPushInputBox()" slot="reference" >推送话术</el-button>
        </el-popover>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'recommendWordDetail',
  props: {
    recommendList: {
      type: Array
    },
    sopDetailList: Object,
    sopChannel: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      arrlist: state => state.work.arrlist,
      index: state => state.work.index,
      topfont: state => state.work.topfont,
      nowlist: state => state.work.nowlist,
      empIds: state => state.work.empIds,
      oldnow: state => state.work.oldnow,
      oldflg: state => state.work.oldflg,
      oldlist: state => state.work.oldlist,
      oldIndex: state => state.work.oldIndex,
      serviceOption: state => state.work.serviceOption
    })
  },  
  methods: {
    isShow() {
      const result = this.recommendList && this.recommendList.length > 0
      if (result && this.sopChannel === 1) {
        try {
          const newstart = JSON.parse(JSON.stringify(this.nowlist))
          window.thinkingReport.track('exposure', {
            page_id: '81120',
            point_id: '29684',
            operation_name: '推送话术曝光',
            component_id: this.sopDetailList.sopId,
            content_type: '人工节点',
            job_num: this.empIds.empId,
            source_content_id: newstart.sessionId,
            order_id: `${this.sopDetailList.targetId}|${this.sopDetailList.targetContent}`
          })
        } catch (e) {
          console.log(e)
        }
      }
      return result
    },
    // 推送到输入框
    getPushInputBox() {
      const val = this.recommendList[this.randomNumBoth(0, this.recommendList.length)].recommendContent
      this.toImEvent(val)
    },
    toImEvent(val) {
      this.$store.dispatch('work/settreecontent', '')
      setTimeout(() => {
        this.$store.dispatch('work/settreecontent', val)
      }, 200)
      if (this.sopChannel === 1) {
        try {
          const newstart = JSON.parse(JSON.stringify(this.nowlist))
          window.thinkingReport.track('others', {
            page_id: '81120',
            point_id: '29685',
            operation_name: '推送话术点击',
            component_id: this.sopDetailList.sopId,
            job_num: this.empIds.empId,
            source_content_id: newstart.sessionId,
            order_id: `${this.sopDetailList.targetId}|${this.sopDetailList.targetContent}`
          })
        } catch (e) {
          console.log(e)
        }
      }
    },
    // 获取一个随机数
    randomNumBoth(Min, Max) {
      const Range = Max - Min
      const Rand = Math.random()
      const num = Min + Math.floor(Rand * Range) // 舍去
      return num
    }
  }
}
</script>
<style lang="less" scoped>
  #recommendWordDetail{
    padding: 10px 6px;
    margin-top: 6px;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #e7e7e7;
    box-shadow: 0px 2px 4px 0px #ccc;
    .card-verbal-trick {
      overflow: hidden;
      margin-top: 16px;
      padding-left: 4px;
      .verbal-trick-title {
        color: #000;
      }
      .verbal-trick-content {
        margin: 0;
        color: #000;
        text-align: left;
      }
      .verbal-trick-btn {
        margin-top: 8px;
        float: right;
        width: 96px;
      }
    }
    .card-verbal-trick:first-child {
      margin: 0;
    }
  }
</style>
